import useSWR from 'swr';

import { Mvpd, tveService } from '#/client';
import { useAuthentication } from '#/store/auth';

/**
 * Hook for accessing TVE MVPD related information.
 * Gets the current MVPD ID, fetches the MVPD list if needed, finds the active MVPD from the list.
 * @returns {Mvpd} The MVPD item.
 */
export const useActiveMvpd = (): Mvpd | undefined => {
  const { isLoggedIn, profile } = useAuthentication();
  const mvpdId = profile?.attributes?.mvpdId;

  const { data: mvpds } = useSWR<Mvpd[], Error>(
    isLoggedIn && mvpdId,
    () =>
      tveService
        .getMvpds()
        .then((res) => res?.data?.mvpds || [])
        .catch((err) => {
          console.warn('Failed to fetch MVPD logos', err);

          return [];
        }),
    {
      revalidateOnFocus: false,
    }
  );

  if (!isLoggedIn || !mvpds || !mvpdId) {
    return;
  }

  return mvpds.find((el) => el.id === mvpdId);
};
